// extracted by mini-css-extract-plugin
export var dropdownButton = "_1o-0";
export var fullWidthDropdownButton = "_1o-1";
export var icon = "_1o-3";
export var iconPlaceholder = "_1o-2";
export var shortcutContainer = "_1o-4";